module.exports = __webpack_public_path__ + "static/img/cy-logo.b53388c6.png";